import { Button, Card, Divider, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import compact from 'lodash/compact';
// import { checkRole } from 'utils/tools';
// import { useSelector } from '@redux';
// import { DynamicObjectType } from 'types/commons';
import TotalOrderItem from '../components/TotalOrderItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/pro-light-svg-icons';
import EditShippingAddressModal from '../components/EditShippingAddressModal';
import OrderDetailAction from './OrderDetailAction';
import { useDispatch, useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import crudActions from '@redux/crudActions';
import QAQCCard from './QAQCCard';
import { useNavigate } from 'react-router-dom';
import { TRANSFER_ORDER_STATUS } from 'constants/constants';
import { isNull } from 'lodash';

const HAS_EDIT_SHIPPING_ADDRESS = [
  {
    value: 'AWAITING_CONFIRMATION',
  },
  {
    value: 'PENDING_PROCESSING',
  },
  {
    value: 'PICKING',
  },
  {
    value: 'CONFIRMED',
  },
  {
    value: 'READY_TO_PICK',
  },
  {
    value: 'CONFIRMED',
    addition: {
      field: 'orderBatchId',
      value: null,
    },
  },
  // 'waiting_for_package',
];

export default function RightContent({ data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);
  const user = useSelector<DynamicObjectType>((state) => state.auth.data);

  const locationCodes = user?.locationCode?.split(',') || [];

  const shippingInformation =
    data?.orderType === 'OFFLINE' ? data?.location : data?.address;

  return (
    <>
      <EditShippingAddressModal
        visible={modal?.editDelivery?.isOpen}
        onCancel={() => dispatch(crudActions.modal.toogleModal({} as any))}
        title="Edit Shipping Information"
      />
      <Space size={20} direction="vertical" className="w-full">
        {data?.statusOms === 'AWAITING_CONFIRMATION' && (
          <Card title={t('orderDetail.validation')}>
            <OrderDetailAction data={data} />
          </Card>
        )}
        {data?.statusOms === 'REJECTED' && (
          <Card title={t('orderDetail.QAQC')}>
            <QAQCCard />
          </Card>
        )}
        <Card title="Related Order">
          <Space size={10} className="w-full" direction="vertical">
            <div className="grid grid-cols-5 gap-4">
              <div className="color-dark-gray font-medium col-span-1">
                Return Orders ID
              </div>
              <div className="col-span-4">
                {data?.orderReturn?.length > 0 && (
                  <Space size={[5, 2]} wrap className="justify-start">
                    {data?.orderReturn?.map((item) => (
                      <div
                        key={item?.id}
                        onClick={() =>
                          navigate(`/orders-return/${item?.id}/show`)
                        }
                        className="cursor-pointer text-highlight"
                      >
                        #{item?.returnNumber || item?.id}
                      </div>
                    ))}
                  </Space>
                )}
              </div>
            </div>
            <div className="grid grid-cols-5 gap-4">
              <div className="color-dark-gray font-medium col-span-1">
                Exchange Orders ID
              </div>
              <div className="col-span-4">
                {data?.orderExchanges?.length > 0 && (
                  <Space size={[5, 2]} wrap className="justify-start">
                    {data?.orderExchanges?.map((item) => (
                      <div
                        key={item?.id}
                        onClick={() =>
                          navigate(`/orders-exchange/${item?.id}/show`)
                        }
                        className="cursor-pointer text-highlight"
                      >
                        #{item?.exchangeNumber || item?.id}
                      </div>
                    ))}
                  </Space>
                )}
              </div>
            </div>
            <div className="d-flex items-center justify-between">
              <div className="color-dark-gray font-medium">Split Orders ID</div>
              <div className="text-highlight">{''}</div>
            </div>
            <div className="color-dark-gray font-medium">
              Transfer Orders ID
            </div>
            {data?.transferOrders?.length > 0 &&
              data?.transferOrders?.map((item) => (
                <Space
                  key={item?.id}
                  size={5}
                  direction="vertical"
                  className="w-full"
                >
                  <div className="flex justify-between items-center">
                    <div
                      key={item?.id}
                      onClick={() =>
                        (locationCodes?.includes(item?.fromWarehouseId) ||
                          isNull(user?.locationCode)) &&
                        navigate(`/transfer-orders/${item?.id}/show`)
                      }
                      className="cursor-pointer text-highlight"
                    >
                      #{item?.toId || item?.id}
                    </div>
                    <div
                      className={`font-semibold ${TRANSFER_ORDER_STATUS['AWAITING_CONFIRMATION']?.textColor}`}
                    >
                      {t(TRANSFER_ORDER_STATUS[item?.status]?.text)}
                    </div>
                  </div>
                </Space>
              ))}
          </Space>
        </Card>
        <Card title={t('orderDetail.customerInfor')}>
          <div>
            <div className="order-info-box__content">
              <div className="order-info-box__content-item color-dark-gray mb-[5px]">
                {data?.customer
                  ? `${data?.customer?.firstName || ''} ${data?.customer?.lastName || ''}`
                  : data?.address?.customerName ||
                    `${data?.address?.firstName || ''} ${data?.address?.lastName || ''}`}
              </div>
              <div className="order-info-box__content-item color-dark-gray opacity-50 mb-[5px]">
                {data?.customer?.email || data?.address?.email}
              </div>
              <div className="order-info-box__content-item color-dark-gray opacity-50">
                {data?.customer?.telephone || data?.address?.telephone}
              </div>
              {/* <div className="order-info-box__content-item d-flex space-between mt-[15px]">
                <div>{t('orderDetail.orderWithin3Months')}</div>
                <b>{t('orderDetail.orderedCount', { count: 10 })}</b>
                <div className="fw-600 color-dark-gray">27</div>
              </div>
              <div className="order-info-box__content-item d-flex space-between mt-[15px]">
                <div>{t('orderDetail.accumulatedAmount')}</div>
                <div className="fw-600 color-dark-gray">5.000.000đ</div>
              </div>
              <div className="order-info-box__content-item d-flex space-between mt-[15px]">
                <div>{t('orderDetail.cancelledWithin3Months')}</div>
                <div className="fw-600 color-dark-gray">10</div>
              </div>
              <div className="order-info-box__content-item d-flex space-between mt-[15px]">
                <div>{t('orderDetail.cancellationRate')}</div>
                <div className="fw-600 text-error-red">5%</div>
              </div> */}
            </div>
          </div>
        </Card>
        {data?.orderType === 'DELIVERY' ? (
          <Card
            title={t('orderDetail.shippingInformation')}
            {...(HAS_EDIT_SHIPPING_ADDRESS.find(
              (e) =>
                e.value === data?.statusOms &&
                (!e.addition ||
                  data?.[e?.addition?.field] === e?.addition?.value),
            ) &&
              !data?.deliveryCode && {
                // && checkRole('orders/[\\d\\w_]+$', user?.rolePermission, 'PATCH', user?.role === 'bypass')
                extra: (
                  <Button
                    onClick={() =>
                      dispatch(
                        crudActions.modal.toogleModal({
                          editDelivery: { isOpen: true },
                        } as any),
                      )
                    }
                    type="text"
                    icon={<FontAwesomeIcon icon={faPenToSquare} />}
                  />
                ),
              })}
          >
            <div>
              <div className="order-info-box__content">
                <div className="order-info-box__content-item fw-600 color-dark-gray mb-[5px]">
                  {data?.address
                    ? `${data?.address?.firstName} ${data?.address?.lastName}`
                    : data?.address?.customerName}
                </div>
                <div className="order-info-box__content-item color-dark-gray opacity-50 mb-[5px]">
                  {data?.address?.email}
                </div>
                <div className="order-info-box__content-item color-dark-gray opacity-50 mb-[5px]">
                  {data?.address?.telephone}
                </div>
                <div className="order-info-box__content-item color-dark-gray mb-[15px] break-words">
                  {compact([
                    data?.address?.addressLine2,
                    compact([
                      data?.address?.addressLine1,
                      data?.address?.ward,
                      data?.address?.district,
                      data?.address?.province,
                    ]).join(', '),
                  ]).join(' | ')}
                </div>
                <Divider className="m-0" />
                <div className="order-info-box__content-item d-flex space-between mt-[15px]">
                  <div>{t('orderDetail.expectedDeliveryPartner')}</div>
                  <div className="fw-600 color-dark-gray">
                    {data?.deliveryType === 'EXTERNAL'
                      ? 'Other'
                      : data?.shippingCarrier?.name || 'N/A'}
                  </div>
                </div>
                <div className="order-info-box__content-item d-flex space-between mt-[15px]">
                  <div>{t('orders.shippingNo')}</div>
                  <a
                    className="fw-600 color-dark-gray"
                    href={data?.orderShipping?.trackingUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {data?.deliveryCode ? `#${data?.deliveryCode}` : '-'}
                  </a>
                </div>
              </div>
              {/* <CreateLogistic data={data} /> */}
              {/* <Divider className="m-0"/>
              <div>
                <b>{t('orderDetail.fees')}</b>
              </div>
              {formatMoney(data?.deliveryData?.shipping_fee)} */}
            </div>
          </Card>
        ) : (
          <Card title={t('orderDetail.shippingInformation')}>
            <div>
              <div className="order-info-box__content">
                <div className="order-info-box__content-item">
                  {shippingInformation?.firstName ||
                  shippingInformation?.lastName
                    ? `${shippingInformation?.firstName} ${shippingInformation?.lastName}`
                    : shippingInformation?.customerName ||
                      shippingInformation?.name}
                </div>
                <div className="order-info-box__content-item description">
                  {shippingInformation?.email}
                </div>
                <div className="order-info-box__content-item description">
                  {shippingInformation?.telephone}
                </div>
                <div className="order-info-box__content-item">
                  {compact([
                    shippingInformation?.name,
                    compact([
                      shippingInformation?.addressLine,
                      shippingInformation?.ward,
                      shippingInformation?.district,
                      shippingInformation?.province,
                    ]).join(', '),
                  ]).join(' | ')}
                </div>
              </div>
              {/* <CreateLogistic data={data} /> */}
            </div>
          </Card>
        )}
        <Card title={t('orderDetail.erpOrderInformation')}>
          <Space size={15} direction="vertical" className="w-full">
            <TotalOrderItem
              boldValue
              title={t('orders.customerOrderId')}
              value={data?.customerOrderId || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.saleOrderId')}
              value={data?.saleOrderId || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.wspId')}
              value={data?.wspId || '-'}
            />
            {data?.lastShippingNo && (
              <TotalOrderItem
                boldValue
                title={t('orders.lastShippingNo')}
                value={data?.lastShippingNo || '-'}
              />
            )}
            <TotalOrderItem
              boldValue
              title={t('orderDetail.postWHReceipt')}
              value={data?.isPostWs ? '√' : '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orderDetail.batchNumber')}
              value={
                data?.orderBatchId
                  ? `${
                      data?.orderBatch?.yymmdd
                        ? `${data?.orderBatch?.yymmdd}${data?.orderBatch?.name}`
                        : data?.orderBatchId
                    }`
                  : '-'
              }
            />
            <TotalOrderItem
              boldValue
              title={t('orderDetail.warehouseReceiptID')}
              value={data?.warehouseReceiptNo || '-'}
            />
            {/* <TotalOrderItem
              boldValue
              title={t('orders.postDate')}
              value={data?.postInvoiceDate || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.invoiceNumber')}
              value={data?.invoiceNumber || '-'}
            /> */}
            {data?.sorId && (
              <TotalOrderItem
                boldValue
                title={t('returnOrders.sorId')}
                value={data?.sorId}
              />
            )}
          </Space>
        </Card>
        <Card title={t('orderDetail.creator')}>
          <Space size={15} direction="vertical" className="w-full">
            <TotalOrderItem
              boldValue
              title={t('transferOrders.createdBy')}
              value={
                data?.creator
                  ? `${data?.creator?.firstName || ''} ${data?.creator?.lastName || ''}`
                  : 'Customer'
              }
            />
          </Space>
        </Card>
        <Card title={t('orderDetail.utm')}>
          <Space size={15} direction="vertical" className="w-full">
            <TotalOrderItem
              boldValue
              title={t('orders.utmId')}
              value={data?.utm?.utm_id || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.source')}
              value={data?.utm?.utm_source || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.medium')}
              value={data?.utm?.utm_medium || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.name')}
              value={data?.utm?.utm_campaign || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.term')}
              value={data?.utm?.utm_term || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.content')}
              value={data?.utm?.utm_content || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.landingSite')}
              value={data?.utm?.utm_landing || '-'}
            />
            <TotalOrderItem
              boldValue
              title={t('orders.referingSite')}
              value={data?.utm?.utm_referring || '-'}
            />
          </Space>
        </Card>
      </Space>
    </>
  );
}
